import type { ReactNode } from 'react';

import type { MqSwitchProps } from './types';
import { useMqSelect } from './use-mq-select';

export function MqSwitch(props: MqSwitchProps) {
  return useMqSelect<() => ReactNode>(props, () => null)();
}
